import React, { useContext, useEffect, useState } from "react";
import WeeklyAnalytics from "../../../components/WeeklyAnalytics";
import TotalSpent from "../../../components/TotalSpent";
// import PieChartCard from "../../../components/PieChartCard";
import DailyTraffic from "../../../components/DailyTraffic";
import { makeApiCall } from "../../../config";
import { FaUsers } from "react-icons/fa";
import {
  MdOutlineCalendarMonth,
  MdOutlineFeaturedVideo,
  MdOutlineFreeCancellation,
} from "react-icons/md";
import { RiPagesLine } from "react-icons/ri";
import { FaRankingStar } from "react-icons/fa6";
import { successToaster, ErrorToaster } from "../../../utils/toaster";
import AuthContext from "../../../context/AuthContext";
import Card from "../../../components/Widget/card";
import Error from "../../../components/Error";
import Loader from "../../../components/Loader";


export default function Analytics() {
  const { enableToaster,getUserInfo } = useContext(AuthContext);
  const [analytics, setAnalytics] = useState(null);
  const [enableLoader, setEnableLoader] = useState(false);

  async function getOverallAnalytics(params) {
    try {
      const res = await makeApiCall("/api/v1/admin/get/analytics/", "get", null, {hostname: params.defaultURL, userId: params._id});
      setAnalytics(res.data);
      enableToaster && successToaster(res.message);
      setEnableLoader(false);
    } catch (error) {
      if (error.response && error.response.status === 422) {
        ErrorToaster(error.response.data.message);
      } else {
        ErrorToaster("Something went wrong");
        console.log("error occurred in getOverallAnalytics", error);
      }
      setEnableLoader(false);
    }
  }
  useEffect(() => {
    setEnableLoader(true);
    (async()=>{
      const userData = await getUserInfo();
      if (userData) {
        await getOverallAnalytics(userData);
      }
    })()
  }, []);

  return (
    <>
      {/* Charts */}
      {enableLoader && <Loader/>}
      {!enableLoader && !analytics && <Error/>}
      {analytics && <main className="mt-6 pb-8">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
          {/* Main 3 column grid */}
          <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-3 lg:gap-8">
            {/* Left column */}
            <div className="grid grid-cols-1 gap-4 lg:col-span-2">
              <section aria-labelledby="section-1-title">
                
                  <div className="grid grid-cols-2 gap-4 lg:col-span-2 mb-4">
                    <Card
                      icon={<FaUsers />}
                      title={"Total Users Visited"}
                      subtitle={analytics.totalUsersVisited || ""}
                    />
                    <Card
                      icon={<MdOutlineCalendarMonth />}
                      title={"User Count In Current Month"}
                      subtitle={analytics.userCountInCurrentMonth || ""}
                    />
                    <Card
                      icon={<RiPagesLine />}
                      title={"Total Page Explored"}
                      subtitle={analytics.totalPageExplored || ""}
                    />
                    <Card
                      icon={<MdOutlineFeaturedVideo />}
                      title={"Top Most Used Features"}
                      subtitle={
                        (analytics.TopMostUsedFeatures &&
                          analytics.TopMostUsedFeatures.length) ||
                        ""
                      }
                    />
                    <Card
                      icon={<MdOutlineFreeCancellation />}
                      title={"Top Most Users Without Free Trial"}
                      subtitle={
                        (analytics.TopMostUsersWithoutFreeTrail &&
                          analytics.TopMostUsersWithoutFreeTrail.length > 0 &&
                          analytics.TopMostUsersWithoutFreeTrail[0].length) ||
                        ""
                      }
                    />
                  </div>
                
                <div className="overflow-hidden rounded-lg bg-white shadow">
                  <div className="p-6">
                    <TotalSpent lineChartData={analytics.lineChartData} totalUsers={analytics?.TopMostUsers?.length}/>
                    {/* <div cl assName="mt-5 ">
                      <WeeklyAnalytics />
                    </div> */}
                  </div>
                </div>
              </section>
            </div>

            {/* Right column */}
            <div className="grid grid-cols-1 gap-4">
              <section aria-labelledby="section-2-title">
                <div className="overflow-hidden rounded-lg bg-white shadow">
                  <div className="p-6">
                   <DailyTraffic Barchart={analytics.BarChart} />

                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>}
    </>
  );
}
